import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getStorage } from "firebase/storage"; // ✅ AGGIUNTO per Storage

// ATTENZIONE: Questi valori vanno recuperati dalla console del tuo progetto Firebase.
// Vai su Project Settings > General > Your apps > Web app > Firebase SDK snippet > Config
const firebaseConfig = {
  apiKey: "AIzaSyBSPwlGR_xsCt2P5b-rIx0C37lDT8Rinbc",
  authDomain: "tp-agents-engine-462708.firebaseapp.com",
  projectId: "tp-agents-engine-462708",
  storageBucket: "tp-agents-engine-462708.firebasestorage.app", // ✅ GIÀ PRESENTE
  messagingSenderId: "79591369583",
  appId: "1:79591369583:web:5187bfacc48a20df86969a",
  measurementId: "G-Z4KYB3JJZE"
};

// Inizializza l'applicazione Firebase
const app = initializeApp(firebaseConfig);

// Esporta l'istanza del servizio di autenticazione
export const auth = getAuth(app);

// Crea ed esporta un'istanza del Google Auth Provider
export const provider = new GoogleAuthProvider();

// ✅ NUOVO: Esporta l'istanza del servizio Storage
export const storage = getStorage(app);

export default app;
